export default "__VITE_ASSET__BjUirD2o__"